export default "__VITE_ASSET__70fc60cc__"